webpackJsonp([5],{

/***/ "7Gmt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _row = __webpack_require__("0b0c");

var _row2 = _interopRequireDefault(_row);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

__webpack_require__("1szz");

var _HistoryContentContainer = __webpack_require__("zRbn");

var _HistoryContentContainer2 = _interopRequireDefault(_HistoryContentContainer);

var _HistoryListContainer = __webpack_require__("WAiY");

var _HistoryListContainer2 = _interopRequireDefault(_HistoryListContainer);

var _NoteHistoryAction = __webpack_require__("AKo5");

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _timeago = __webpack_require__("al8S");

var _timeago2 = _interopRequireDefault(_timeago);

var _formatDate = __webpack_require__("3KG0");

var _formatDate2 = _interopRequireDefault(_formatDate);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _variables = __webpack_require__("+AJo");

var _HistoryPage = __webpack_require__("8LzJ");

var _HistoryPage2 = _interopRequireDefault(_HistoryPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// containers
// import TestI18N from '../../components/TestI18N/TestI18N';

var HistoryPage = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, function (dispatch) {
  return {
    resetNoteHistory: function resetNoteHistory() {
      return dispatch((0, _NoteHistoryAction.resetNoteHistory)());
    }
  };
}), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
  (0, _inherits3.default)(HistoryPage, _Component);

  function HistoryPage(props) {
    (0, _classCallCheck3.default)(this, HistoryPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HistoryPage.__proto__ || (0, _getPrototypeOf2.default)(HistoryPage)).call(this, props));

    _this.state = {
      page: 'home',
      size: 'large'
    };
    return _this;
  }

  (0, _createClass3.default)(HistoryPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // 首次进来需要重置数据
      this.props.resetNoteHistory();
    }
  }, {
    key: 'render',
    value: function render() {
      var match = this.props.match;

      return _react2.default.createElement(
        _row2.default,
        { className: _HistoryPage2.default['history-page'] },
        _react2.default.createElement(_HistoryListContainer2.default, null),
        _react2.default.createElement(_HistoryContentContainer2.default, null)
      );
    }
  }]);
  return HistoryPage;
}(_react.Component)) || _class) || _class);
exports.default = HistoryPage;

/***/ }),

/***/ "8LzJ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("OVmf");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryPage.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryPage.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AKo5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restoreNoteHistoryContent = exports.getNoteHistoryContent = exports.getNoteHistoryList = exports.resetNoteHistory = undefined;

var _actionTypes = __webpack_require__("4HHy");

var _createAction = __webpack_require__("lTDY");

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
/**
 * Created by zad on 17/4/25.
 */
var resetNoteHistory = exports.resetNoteHistory = (0, _createAction2.default)(_actionTypes.NoteHistory.NOTE_HISTORY_INIT); // 重置NoteHistory数据

var getNoteHistoryList = exports.getNoteHistoryList = (0, _createAction2.default)(_actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST, 'noteId');

var getNoteHistoryContent = exports.getNoteHistoryContent = (0, _createAction2.default)(_actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT, 'historyId', 'noteId');

var restoreNoteHistoryContent = exports.restoreNoteHistoryContent = (0, _createAction2.default)(_actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT, 'nbId', 'noteId', 'historyId');

/***/ }),

/***/ "OVmf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._10ibe{height:100%}", ""]);

// exports
exports.locals = {
	"history-page": "_10ibe"
};

/***/ }),

/***/ "WAiY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _reactRouterDom = __webpack_require__("F8kA");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _HistoryListContainer = __webpack_require__("bpb/");

var _HistoryListContainer2 = _interopRequireDefault(_HistoryListContainer);

var _actionTypes = __webpack_require__("4HHy");

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _NoteHistoryReducer = __webpack_require__("qiO7");

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _NoteHistoryAction = __webpack_require__("AKo5");

var _timeago = __webpack_require__("al8S");

var _timeago2 = _interopRequireDefault(_timeago);

var _formatDate = __webpack_require__("3KG0");

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HistoryListContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    noteHistory: (0, _NoteHistoryReducer.getNoteHistoryState)(state)
  };
}, function (dispatch) {
  return {
    getNoteHistoryList: function getNoteHistoryList(noteId) {
      return dispatch((0, _NoteHistoryAction.getNoteHistoryList)(noteId));
    }
  };
}), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
  (0, _inherits3.default)(HistoryListContainer, _Component);

  function HistoryListContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HistoryListContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HistoryListContainer.__proto__ || (0, _getPrototypeOf2.default)(HistoryListContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showFilterList: false,
      filterItems: [{
        text: _reactIntlUniversal2.default.get('history.auto-save'),
        logType: 1,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.publicize'),
        logType: 2,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.update'),
        logType: 3,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.recovery'),
        logType: 4,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.web'),
        app: 4, // app来源
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.ios'),
        app: 1,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.android'),
        app: 2,
        checked: true
      }, {
        text: _reactIntlUniversal2.default.get('history.ios-night'),
        app: 3,
        checked: true
      }]
    }, _this.onFilterItemChange = function (index, e) {
      var data = _this.state.filterItems[index];
      data.checked = !data.checked;
      _this.setState({
        filterItems: _this.state.filterItems
      });
    }, _this.renderFilterItems = function () {
      var filterItems = _this.state.filterItems;

      return filterItems.map(function (v, k) {
        return _react2.default.createElement(
          'label',
          { className: 'checkbox', key: k },
          _react2.default.createElement('input', {
            type: 'checkbox',
            checked: v.checked,
            'data-note-log-type': v.logType,
            onChange: function onChange(e) {
              return _this.onFilterItemChange(k, e);
            }
          }),
          v.text
        );
      });
    }, _this.onHistoryItemClick = function (e, historyId) {}, _this.getDisplayName = function (prop, v) {
      var filterItems = _this.state.filterItems;

      var textObj = filterItems.filter(function (fitem) {
        return fitem[prop] === v;
      }) || [{}];
      return textObj[0].text || '';
    }, _this.noteListItemOnMouseMove = function (e) {
      var spanElem = e.currentTarget.querySelector('span');
      spanElem.innerHTML = spanElem.getAttribute('data-title');
    }, _this.noteListItemOnMouseLeave = function (e) {
      var spanElem = e.currentTarget.querySelector('span');
      spanElem.innerHTML = spanElem.getAttribute('data-timeago');
    }, _this.renderHistoryItems = function (items) {
      var _this$props = _this.props,
          noteHistory = _this$props.noteHistory,
          match = _this$props.match;
      var _match$params = match.params,
          nbId = _match$params.nbId,
          noteId = _match$params.noteId,
          historyId = _match$params.historyId;

      return items.map(function (v, k) {
        var itemClasses = (0, _classnames2.default)((0, _defineProperty3.default)({}, _HistoryListContainer2.default['active'], +historyId === v.id));
        var timeAgo = (0, _timeago2.default)(v.updated_at * 1000, _reactIntlUniversal2.default.get('history.timeago'));
        return _react2.default.createElement(
          'li',
          {
            key: k,
            className: itemClasses,
            onMouseMove: _this.noteListItemOnMouseMove,
            onMouseLeave: _this.noteListItemOnMouseLeave
          },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/notebooks/' + nbId + '/notes/' + noteId + '/history/' + v.id },
            _react2.default.createElement(
              'span',
              {
                'data-title': (0, _formatDate2.default)(new Date(v.updated_at * 1000), 'yyyy-MM-dd hh:mm'),
                'data-formatted-created-at': v.updated_at,
                'data-timeago': timeAgo
              },
              timeAgo
            ),
            _this.getDisplayName('logType', v.note_log_type)
          )
        );
      });
    }, _this.toggleFilterList = function () {
      _this.setState({
        showFilterList: !_this.state.showFilterList
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HistoryListContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          match = _props.match,
          history = _props.history;
      var _match$params2 = match.params,
          nbId = _match$params2.nbId,
          noteId = _match$params2.noteId;

      this.props.getNoteHistoryList(noteId);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var match = nextProps.match,
          history = nextProps.history,
          noteHistory = nextProps.noteHistory;
      var _match$params3 = match.params,
          nbId = _match$params3.nbId,
          noteId = _match$params3.noteId,
          historyId = _match$params3.historyId;

      var noteHistoryList = noteHistory.get('list');
      // 首次进来有可能存在没有historyId的情况
      if (!historyId && noteHistoryList.size > 0) {
        var hid = noteHistoryList.first().get('id');
        history.replace('/notebooks/' + nbId + '/notes/' + noteId + '/history/' + hid);
      }
    }
    // 获取filterItems中的text字段，用于显示listitem

  }, {
    key: 'render',


    // eslint-disable-next-line class-methods-use-this
    value: function render() {
      var noteHistory = this.props.noteHistory;
      var _state = this.state,
          showFilterList = _state.showFilterList,
          filterItems = _state.filterItems;

      var filterListClasses = (0, _classnames2.default)(_HistoryListContainer2.default['filter-factors-list'], (0, _defineProperty3.default)({}, _HistoryListContainer2.default['filter-factors-list__active'], showFilterList));
      var noteHistoryStatus = noteHistory.get('status');
      var loading = noteHistoryStatus === _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST; // 正在获取则显示loading

      // 选中的过滤条件
      var logTypeCheckedItems = filterItems.filter(function (v) {
        return v.checked;
      }).map(function (v) {
        return v.logType;
      }).filter(function (v) {
        return v;
      });
      var appFromCheckedItems = filterItems.filter(function (v) {
        return v.checked;
      }).map(function (v) {
        return v.app;
      }).filter(function (v) {
        return v;
      });
      // 对noteHistory过滤
      var historyItems = noteHistory.get('list').toJS().filter(function (v) {
        return logTypeCheckedItems.indexOf(v.note_log_type) > -1;
      }).filter(function (v) {
        return appFromCheckedItems.indexOf(v.app) > -1;
      });
      return _react2.default.createElement(
        'div',
        { className: _HistoryListContainer2.default['history-list-wrap'] },
        _react2.default.createElement(
          'div',
          { className: _HistoryListContainer2.default['filter-wrap'] },
          _react2.default.createElement(
            'div',
            { className: _HistoryListContainer2.default['filer-title'] },
            _react2.default.createElement(_Icon2.default, { name: 'history', className: _HistoryListContainer2.default['icon-clock-o'] }),
            _reactIntlUniversal2.default.get('history.total-items', { num: historyItems.length }),
            _react2.default.createElement(
              'span',
              { className: _HistoryListContainer2.default['filter-contol-btn'], onClick: this.toggleFilterList },
              _reactIntlUniversal2.default.get('history.filter'),
              _react2.default.createElement(_Icon2.default, { name: 'angle-double-down', className: _HistoryListContainer2.default['icon-clock-o'] })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: filterListClasses },
            this.renderFilterItems()
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: _HistoryListContainer2.default['history-list'] },
          this.renderHistoryItems(historyItems),
          _react2.default.createElement(_NestLoading2.default, {
            loading: loading
          })
        )
      );
    }
  }]);
  return HistoryListContainer;
}(_react.Component)) || _class) || _class);
exports.default = HistoryListContainer;

/***/ }),

/***/ "al8S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getType(arg) {
  return Object.prototype.toString.call(arg);
}

/**
 * timeago date format function
 * @param  {Date} date                    格式化的时间，Date构造函数所支持的参数这里都支持
 * @param(option) {String} localesConfig  例如：'刚刚_秒以前_分钟以前_小时以前_天以前_周以前_月以前_年以前'
 * @param(option) {Array} secArray        和localesConfig相对应的时间划分尺度，默认10秒内会显示刚刚
 * @return {String}                       例如：30秒以前
 */
function timeago(date) {
  var localesConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var secArray = arguments[2];

  if (!date) {
    return '';
  }
  var indexMap = localesConfig.split('_'); // indexMap的length必须要比secArray的length多一个
  var SEC_ARRAY = secArray || [10, 60, 60, 24, 7, 365 / 7 / 12, 12];
  var SEC_ARRAY_LEN = SEC_ARRAY.length;

  function toInt(number) {
    return parseInt(number, 10);
  }
  // format Date / string / timestamp to Date instance.
  function toDate(input) {
    if (input instanceof Date) return input;
    return new Date(input);
  }

  // 多语言处理
  function localeProcess(number, index) {
    if (indexMap.length !== SEC_ARRAY_LEN + 1) {
      // 如果传入的参数不对，只返回时间差值以及当前所在的单位
      return [number, index];
    }
    if (index === 0) return indexMap[0];
    var unit = indexMap[toInt(index)];
    return '' + number + unit;
  }
  // format the diff second to *** time ago, with setting locale
  function formatDiff(diff) {
    var i = 1;
    // total_sec = diff = Math.abs(diff);
    // 小于10秒的话特殊处理，显示为刚刚的情况
    if (diff < SEC_ARRAY[0]) {
      return localeProcess(diff, 0);
    }
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY_LEN; i++) {
      diff /= SEC_ARRAY[i]; // eslint-disable-line no-param-reassign
    }
    diff = toInt(diff); // eslint-disable-line no-param-reassign
    return localeProcess(diff, i);
  }
  var diff = new Date() - toDate(date);
  return formatDiff(diff / 1000);
}

exports.default = timeago;

/***/ }),

/***/ "bpb/":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("wJcL");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryListContainer.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryListContainer.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ijjv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3Kp23{height:100%;margin:0 0 0 300px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}body.reader-night-mode ._3Kp23{background-color:#3d3d3d}._3Kp23 ._3vp73{position:relative;padding:20px;border-bottom:1px solid #d9d9d9}body.reader-night-mode ._3Kp23 ._3vp73{border-color:#2e2e2e}._3Kp23 ._3vp73 h3{margin:0 365px 0 20px;line-height:40px;height:40px;font-size:24px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._3Kp23 ._3vp73 h3{color:#b3b3b3}._3Kp23 ._3vp73 ._1Zkg0{position:absolute;right:260px;bottom:26px}body.reader-night-mode ._3Kp23 ._3vp73 ._1Zkg0{color:#b3b3b3}._3Kp23 ._3vp73 ._2TjmB{position:absolute;top:2px;right:20px;cursor:pointer;background:transparent;border:0;padding:5px;font-size:40px}body.reader-night-mode ._3Kp23 ._3vp73 ._2TjmB{color:#b3b3b3}._3Kp23 ._3vp73 .wuk6K{display:block;position:absolute;top:20px;right:66px;color:#fff;border-color:#42c02e;background-color:#42c02e;border-radius:4px;-webkit-box-shadow:none;box-shadow:none;text-shadow:none;padding:11px 19px;font-size:17.5px;text-align:center;cursor:pointer;line-height:20px;-webkit-transition:padding .3s cubic-bezier(.645,.045,.355,1);-o-transition:padding .3s cubic-bezier(.645,.045,.355,1);transition:padding .3s cubic-bezier(.645,.045,.355,1)}._3Kp23 ._3vp73 .wuk6K .fa{margin:0 -33px 0 5px;opacity:0;display:none;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1)}._3Kp23 ._3vp73 .Lp5tT{pointer-events:none;padding-right:43px;opacity:.6}._3Kp23 ._3vp73 .Lp5tT .fa{display:inline-block;opacity:1}._3Kp23 ._33LvZ{overflow-y:auto;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;height:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._3Kp23 ._33LvZ ._1mtk4{margin:0 auto;max-width:800px;padding:40px 0}", ""]);

// exports
exports.locals = {
	"history-view": "_3Kp23",
	"revision-top": "_3vp73",
	"time-tag": "_1Zkg0",
	"close": "_2TjmB",
	"revert-btn": "wuk6K",
	"revert-btn__loading": "Lp5tT",
	"view-area-wrap": "_33LvZ",
	"note-view": "_1mtk4"
};

/***/ }),

/***/ "rxIi":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("ijjv");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryContentContainer.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HistoryContentContainer.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wJcL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".SJkAD{position:fixed;top:0;left:0;bottom:0;width:300px;background:#fff;border-right:1px solid #d9d9d9;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}body.reader-night-mode .SJkAD{border-color:#2e2e2e}.SJkAD ._24LeD{padding:12px;background:#404040;color:#f2f2f2;font-size:14px}.SJkAD ._24LeD ._3WaPV{line-height:20px}.SJkAD ._24LeD ._3WaPV ._35zzW{float:right;font-size:12px;color:#e6e6e6;cursor:pointer}.SJkAD ._24LeD ._3WaPV ._35zzW i{margin-left:5px}.SJkAD ._24LeD ._3ciQq{height:0;margin-top:0;padding-top:0;border-top:1px solid transparent;overflow:hidden;-webkit-transition:all .4s cubic-bezier(.12,.4,.29,1.46);-o-transition:all .4s cubic-bezier(.12,.4,.29,1.46);transition:all .4s cubic-bezier(.12,.4,.29,1.46)}.SJkAD ._24LeD ._1pDW4{height:195px;margin-top:15px;padding-top:10px;border-color:#333;overflow-y:auto}.SJkAD ._24LeD ._3ciQq label{display:block;font-size:12px;margin-bottom:5px;cursor:pointer}.SJkAD ._24LeD ._3ciQq input[type=checkbox]{float:left;width:12px;-webkit-appearance:checkbox;margin:3px 5px 0 0}.SJkAD ._334h2{overflow-y:auto;margin-bottom:0;height:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}body.reader-night-mode .SJkAD ._334h2{background-color:#3d3d3d}.SJkAD ._334h2 li{display:block;border-bottom:1px solid #d9d9d9;border-left:3px solid transparent;font-size:12px}body.reader-night-mode .SJkAD ._334h2 li{border-bottom-color:#2e2e2e}.SJkAD ._334h2 li:hover{background-color:#e6e6e6}body.reader-night-mode .SJkAD ._334h2 li:hover{background-color:#2e2e2e}.SJkAD ._334h2 li._3oo40{background-color:#e6e6e6;border-left:3px solid #ec7259}body.reader-night-mode .SJkAD ._334h2 li._3oo40{background-color:#2e2e2e}.SJkAD ._334h2 li>a{padding:12px 10px;display:block;line-height:20px;height:44px;color:#595959}body.reader-night-mode .SJkAD ._334h2 li>a{color:#b3b3b3}.SJkAD ._334h2 li>a span{float:right;color:#999}", ""]);

// exports
exports.locals = {
	"history-list-wrap": "SJkAD",
	"filter-wrap": "_24LeD",
	"filer-title": "_3WaPV",
	"filter-contol-btn": "_35zzW",
	"filter-factors-list": "_3ciQq",
	"filter-factors-list__active": "_1pDW4",
	"history-list": "_334h2",
	"active": "_3oo40"
};

/***/ }),

/***/ "zRbn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _reactRouterDom = __webpack_require__("F8kA");

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _doyle = __webpack_require__("Gr4k");

var _doyle2 = _interopRequireDefault(_doyle);

var _HistoryContentContainer = __webpack_require__("rxIi");

var _HistoryContentContainer2 = _interopRequireDefault(_HistoryContentContainer);

var _actionTypes = __webpack_require__("4HHy");

var _NoteHistoryAction = __webpack_require__("AKo5");

var _NoteHistoryReducer = __webpack_require__("qiO7");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _formatDate = __webpack_require__("3KG0");

var _formatDate2 = _interopRequireDefault(_formatDate);

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _util = __webpack_require__("oFuF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doyle = new _doyle2.default();

var HistoryContentContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    noteHistory: (0, _NoteHistoryReducer.getNoteHistoryState)(state)
  };
}, function (dispatch) {
  return {
    getNoteHistoryContent: function getNoteHistoryContent(historyId, noteId) {
      dispatch((0, _NoteHistoryAction.getNoteHistoryContent)(historyId, noteId));
    },
    restoreNoteHistoryContent: function restoreNoteHistoryContent(nbId, noteId, historyId) {
      dispatch((0, _NoteHistoryAction.restoreNoteHistoryContent)(nbId, noteId, historyId));
    }
  };
}), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
  (0, _inherits3.default)(HistoryContentContainer, _Component);

  function HistoryContentContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HistoryContentContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HistoryContentContainer.__proto__ || (0, _getPrototypeOf2.default)(HistoryContentContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false,
      isRevertBtnLoading: false
    }, _this.revertBtnClick = function () {
      var match = _this.props.match;
      var _match$params = match.params,
          nbId = _match$params.nbId,
          noteId = _match$params.noteId,
          historyId = _match$params.historyId;
      var isRevertBtnLoading = _this.state.isRevertBtnLoading;

      if (isRevertBtnLoading || !historyId) {
        return;
      } // 正在请求后端恢复版本
      _this.setState({
        isRevertBtnLoading: true
      });
      _this.props.restoreNoteHistoryContent(nbId, noteId, historyId); // send action
    }, _this.getNoteType = function () {
      var _this$props = _this.props,
          match = _this$props.match,
          noteHistory = _this$props.noteHistory;
      var historyId = match.params.historyId;

      var historyItem = noteHistory.get('list').find(function (v) {
        return '' + v.get('id') === '' + historyId;
      }) || _immutable2.default.fromJS({});
      return historyItem.get('note_type');
    }, _this.getContentHTML = function () {
      var _this$props2 = _this.props,
          match = _this$props2.match,
          noteHistory = _this$props2.noteHistory;
      var historyId = match.params.historyId;

      var noteType = _this.getNoteType();
      var content = noteHistory.getIn(['contents', 'entities', historyId, 'content'], '');
      // 2 --> markdown
      if (noteType === 2) {
        return doyle.parse(content);
      }
      return content;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HistoryContentContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var match = this.props.match;
      var _match$params2 = match.params,
          historyId = _match$params2.historyId,
          noteId = _match$params2.noteId;

      if (historyId) {
        this.props.getNoteHistoryContent(historyId, noteId);
      }
      // 首次挂载时需要
      this.setState({
        loading: true
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var noteHistory = nextProps.noteHistory,
          history = nextProps.history,
          match = nextProps.match;
      var _match$params3 = match.params,
          nextHistoryId = _match$params3.historyId,
          nbId = _match$params3.nbId,
          noteId = _match$params3.noteId;

      var curHistoryId = this.props.match.params.historyId;
      // 获取content
      if (nextHistoryId !== curHistoryId) {
        this.props.getNoteHistoryContent(nextHistoryId, noteId);
      }

      var getContentsStatus = noteHistory.getIn(['contents', 'status']); // 获取内容的action状态
      var restoreStatus = noteHistory.getIn(['restore', 'status']); // 恢复版本的action状态
      this.setState({
        loading: getContentsStatus === _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT,
        isRevertBtnLoading: restoreStatus === _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT
      });

      // 成功恢复时
      if (restoreStatus === _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS) {
        history.push('/notebooks/' + nbId + '/notes/' + noteId + '/');
      }
      // 恢复失败时需要提示
      if (restoreStatus === _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL) {
        _Message2.default.error('error.try-again');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.noteWrapElem) {
        (0, _util.formatTheVideoPackage)(this.noteWrapElem);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          match = _props.match,
          noteHistory = _props.noteHistory;
      var _match$params4 = match.params,
          nbId = _match$params4.nbId,
          noteId = _match$params4.noteId,
          historyId = _match$params4.historyId;
      var _state = this.state,
          loading = _state.loading,
          isRevertBtnLoading = _state.isRevertBtnLoading;

      var noteList = noteHistory.getIn(['list'], _immutable2.default.fromJS([])).toJS();
      var noteContentItem = noteHistory.getIn(['contents', 'entities', historyId], _immutable2.default.fromJS({})).toJS();
      var noteTitle = noteContentItem.title || '';
      var noteListItem = noteList.filter(function (v) {
        return v.id === noteContentItem.id;
      })[0];
      var updatedAt = '';
      if (noteListItem) {
        updatedAt = (0, _formatDate2.default)(new Date(noteListItem.updated_at * 1000), 'yyyy-MM-dd hh:mm');
      }
      var contentHTML = this.getContentHTML();
      var revertBtnClasses = (0, _classnames2.default)(_HistoryContentContainer2.default['revert-btn'], (0, _defineProperty3.default)({}, _HistoryContentContainer2.default['revert-btn__loading'], isRevertBtnLoading));
      return _react2.default.createElement(
        'div',
        { className: _HistoryContentContainer2.default['history-view'] },
        _react2.default.createElement(
          'div',
          { className: _HistoryContentContainer2.default['revision-top'] },
          _react2.default.createElement(
            'h3',
            null,
            noteTitle
          ),
          _react2.default.createElement(
            'span',
            { className: _HistoryContentContainer2.default['time-tag'] },
            updatedAt
          ),
          !isRevertBtnLoading && _react2.default.createElement(
            _reactRouterDom.Link,
            { className: _HistoryContentContainer2.default['close'], to: '/notebooks/' + nbId + '/notes/' + noteId + '/' },
            '\xD7'
          ),
          _react2.default.createElement(
            'span',
            { className: revertBtnClasses, onClick: this.revertBtnClick },
            _reactIntlUniversal2.default.get('history.recovery-to'),
            _react2.default.createElement(_Icon2.default, { name: 'spinner', spin: true })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _HistoryContentContainer2.default['view-area-wrap'] },
          _react2.default.createElement('div', {
            className: (0, _classnames2.default)('note-view', _HistoryContentContainer2.default['note-view']),
            dangerouslySetInnerHTML: { __html: contentHTML },
            ref: function ref(v) {
              _this2.noteWrapElem = v;
            }
          }),
          _react2.default.createElement(_NestLoading2.default, { loading: loading, hasMask: true })
        )
      );
    }
  }]);
  return HistoryContentContainer;
}(_react.Component)) || _class) || _class);
exports.default = HistoryContentContainer;

/***/ })

});


// WEBPACK FOOTER //
// static/js/history.chunk.abe59c960cc869ece42f.js